import { IDiaryService, IBooking, IBookingLink } from 'shared-types/index';
import { IServiceViewList } from 'app/services/bookingsUtils/bookingUtils.service.type';
import DateUtilsService from 'external-services/date-utils-service';

const NS = 'BookingsUtilsService'; // jshint ignore:line

class BookingsUtilsService {
  // private editBookingOriginal: any;
  private editBookingOriginal: IBooking = null;


  setEditBookingOriginal(orgBooking: IBooking): void {
    this.editBookingOriginal = orgBooking;
  }

  getEditBookingOriginal(): IBooking {
    return this.editBookingOriginal;
  }

  /**
   * Loops through serviceViewList and returns an index that matches either a booking's
   * serviceId or falls in between it's start and end times. Since there can only be one service
   * per booking, this has been changed to a single value, rather than an array.
   * @returns index from the serviceViewList when returnAsIndex = true. Otherwise an
   * object of the service when returnAsIndex = false
   */
  getServiceFromBooking(booking: IBooking, serviceViewList: IServiceViewList[], returnAsIndex = true): number | IDiaryService {

    const serviceView = serviceViewList.find((item, i) => {

      const service = item.service;

      // in case the service has been deleted
      if (!service) {
        return false;
      }

      const startTime = service.startTime;
      const endTime = service.endTime;

      if (booking.serviceId) {
        // check the service via the serviceId
        if (booking.serviceId === service._id) {
          return true;
        }
      } else {
        /**
         * @todo: don't think this can ever be called
         * Even if it can be called, it appears to be including the any service that matches the time of the
         * booking, even if that booking wasn't assigned to that service. Need to check if this is desired functionality.
         * UPDATE: See NBI-1692 - maybe older bookings may have been able to save the booking without the service and table
         * attached to it (if service or table was deleted), but this is no longer allowed - validation blocks it or forces
         * another service to be chosen.
         */
        if (DateUtilsService.isInBetweenDates(booking.time, startTime, endTime)) {
          return true;
        }
      }

      return false;
    }, []);

    if (returnAsIndex) {
      const indexOfService = serviceViewList.indexOf(serviceView);
      // if not found return -1
      if (indexOfService === -1) {
        return -1;
      }
      return indexOfService;
    }

    // return service object
    return serviceView.service;
  }

  clearBookingIdentifiers(booking: IBooking): void {
    if (booking._rev) {
      delete booking._rev;
    }

    if (booking._id) {
      delete booking._id;
    }

    //When we change id we also need to clear our time changelog
    booking.timeChangelog = [];
  }

  addBookingLink(bookingLinks: IBookingLink[]): IBookingLink[] {
    const newBookingLink: IBookingLink = {
      linkName: '',
      linkURL: ''
    };
    bookingLinks.push(newBookingLink);
    return bookingLinks;
  }
}
const instance = new BookingsUtilsService();
export default instance as BookingsUtilsService;
